import { render, staticRenderFns } from "./wf-dynamic-list-textarea-display.vue?vue&type=template&id=9db5a1e0&scoped=true&"
import script from "./wf-dynamic-list-textarea-display.vue?vue&type=script&lang=ts&"
export * from "./wf-dynamic-list-textarea-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-dynamic-list-textarea-display.vue?vue&type=style&index=0&id=9db5a1e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db5a1e0",
  null
  
)

export default component.exports